import localConfig from './localConfig'
import commonConfig from '../common/config'

export const APP_NAME = require('../../package.json').name

export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const APP_PORT = localConfig.port
export const APP_URL = localConfig.url
export const SSR_URL = localConfig.ssrUrl

// export const APP_VERSION = process.env.appVersion || process.env.HEROKU_SLUG_COMMIT
// console.log('APP_VERSION', APP_VERSION)
const config = {
  appName: APP_NAME,
  appVersion: '0.1.402',
  appUrl: localConfig.url,
  isProduction: IS_PRODUCTION,
  initDirs: ['downloads', 'files', 'files/signs', 'uploads', 'uploads/image-notes'],
  resetValidTo: 24 * 60 * 60 * 1000,
  sentryUrl: '',
}

const nconf = {}
const finalConfig = Object.assign(config, commonConfig, localConfig)
nconf.get = () => finalConfig
export default nconf.get()



// WEBPACK FOOTER //
// ./src/server/config.js